export default function unique(value: any, index: number, self: any[]) {
  return self.indexOf(value) === index;
}
